import { Outlet } from "react-router-dom";
import { AdminSidebar } from "./AdminSidebar";

export function AdminLayout() {
  return (
    <div className="min-h-screen bg-app transition-colors duration-200">
      <AdminSidebar />
      <main id="main-content" className="ml-64">
        <Outlet />
      </main>
    </div>
  );
}
